// Angular
import { Component } from '@angular/core';
@Component({
    selector: 'header-public',
    templateUrl: './header-public.component.html',
})
export class HeaderPublicComponent {}
